// extracted by mini-css-extract-plugin
module.exports = {"link":"link___2VWAK","tab":"tab___CzqSc","is-active":"is-active___20HrS","is-warning":"is-warning___xhDGa"};